export default __webpack_public_path__ + "static/sc-federal-db22965bff420c8c9d7bf6e630a120a0.webp";